import type { MainRootState } from '../Navigation';
import { useSelector } from 'react-redux';

export const useUserLogin = () => {
  return useSelector((rootState: MainRootState) => {
    const { scopes, checkLogin } = rootState['main'];

    return {
      permissionList: scopes?.permissionList ?? [],
      user: checkLogin,
      id: checkLogin?.id ?? '',
      email: checkLogin?.email ?? '',
      phone: checkLogin?.phone ?? '',
      username: checkLogin?.name ?? '',
      isLoggedin: checkLogin ? checkLogin.isLoggedin : false,
      isLoading: scopes?.isLoading ?? false,
      isRequestAccessFlow: checkLogin?.isRequestAccessFlow ?? false,
    };
  });
};
